/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';

// Services
import { WaitSpinnerService } from './service/WaitSpinnerService';
import { NotificationService } from './service/NotificationService';
import { DateTimeService } from './service/DateTimeService';
import { DialogService } from './service/DialogService';
import { FilterService } from './service/FilterService';
import { LocalizationServiceProvider } from './service/LocalizationServiceProvider';
import { ApplicationInfoServiceProvider } from './service/ApplicationInfoServiceProvider';

// Components
import { gmaoContextualTabsComponent } from './component/GmaoContextualTabs';
import { gmaoFiltersComponent } from './component/GmaoFilters';
import { gmaoFormButtonsComponent } from './component/GmaoFormButtons';
import { gmaoInputCategoryComponent } from './component/GmaoInputCategory';
import { gmaoInputCheckboxComponent } from './component/GmaoInputCheckbox';
import { gmaoInputDateComponent } from './component/GmaoInputDate';
import { gmaoInputTimeComponent } from "./component/GmaoInputTime";
import { gmaoInputEmailComponent } from './component/GmaoInputEmail';
import { gmaoInputNumberComponent } from './component/GmaoInputNumber';
import { gmaoInputTelComponent } from './component/GmaoInputTel';
import { gmaoInputTextComponent } from './component/GmaoInputText';
import { gmaoNotifierComponent } from './component/GmaoNotifier';
import { gmaoSelectComponent } from './component/GmaoSelect';
import { gmaoSelectAutocompleteComponent } from './component/GmaoSelectAutocomplete';
import { gmaoTextareaComponent } from './component/GmaoTextarea';
import { gmaoUserComponent } from './component/GmaoUser';
import { gmaoViewHeaderComponent } from './component/GmaoViewHeader';
import { gmaoViewportComponent } from './component/GmaoViewport';
import { gmaoWaitSpinnerComponent } from './component/GmaoWaitSpinner';
import { NotFoundComponent } from './component/NotFound';
import { CounterService } from './service/CounterService';
import { gmaoApplicationInfoComponent } from "./component/GmaoApplicationInfo";

angular.module('serfimtic.gmao.util', [])
.provider('localizationService', LocalizationServiceProvider)
.provider('applicationInfoService', ApplicationInfoServiceProvider)
.service('waitSpinnerService', WaitSpinnerService)
.service('notificationService', NotificationService)
.service('dateTimeService', DateTimeService)
.service('dialogService', DialogService)
.service('filterService', FilterService)
.service('counterService', CounterService)
.config(localizationServiceProvider => {
    /** @ngInject */
    localizationServiceProvider.setUrl(Configuration.LOCALIZATION_URL);
})
.config(applicationInfoServiceProvider => {
    /** @ngInject */
    applicationInfoServiceProvider.setUrl(Configuration.APPLICATION_INFO);
})
.component('gmaoApplicationInfo', gmaoApplicationInfoComponent)
.component('gmaoContextualTabs', gmaoContextualTabsComponent)
.component('gmaoFilters', gmaoFiltersComponent)
.component('gmaoFormButtons', gmaoFormButtonsComponent)
.component('gmaoInputCategory', gmaoInputCategoryComponent)
.component('gmaoInputCheckbox', gmaoInputCheckboxComponent)
.component('gmaoInputDate', gmaoInputDateComponent)
.component('gmaoInputTime', gmaoInputTimeComponent)
.component('gmaoInputEmail', gmaoInputEmailComponent)
.component('gmaoInputNumber', gmaoInputNumberComponent)
.component('gmaoInputTel', gmaoInputTelComponent)
.component('gmaoInputText', gmaoInputTextComponent)
.component('gmaoNotifier', gmaoNotifierComponent)
.component('gmaoSelect', gmaoSelectComponent)
.component('gmaoSelectAutocomplete', gmaoSelectAutocompleteComponent)
.component('gmaoTextarea', gmaoTextareaComponent)
.component('gmaoUser', gmaoUserComponent)
.component('gmaoViewHeader', gmaoViewHeaderComponent)
.component('gmaoViewport', gmaoViewportComponent)
.component('gmaoWaitSpinner', gmaoWaitSpinnerComponent)
.component('notFound', NotFoundComponent);



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/UtilModule.js